module.exports = __webpack_public_path__ + "img/img19.4d06d6ee.png";